// axios基础的封装
import axios from "axios";
import { ElMessage } from "element-plus";
import { useUserStore } from "@/stores/userStore";
const httpInstance = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
  timeout: 10000,
});

// 拦截器

// axios请求拦截器
httpInstance.interceptors.request.use(
  (config) => {
    // 1. 从pinia获取token数据
    const userStore = useUserStore();
    if (
      userStore?.header?.value &&
      Object.keys(userStore.header.value).length > 0
    ) {
      config.headers = userStore.header.value;
    }
    return config;
  },
  (e) => Promise.reject(e)
);

// axios响应式拦截器
httpInstance.interceptors.response.use(
  (res) => {
    if (res.data.error_code === 0) {
      return Promise.resolve(res.data);
    } else {
      ElMessage.error(res.data.error_message || "未知错误");
      return Promise.reject(res.data);
    }
  },
  (e) => {
    console.log(e);
    // 统一错误提示
    ElMessage({
      type: "warning",
      message: e.message,
    });
    return Promise.reject(e);
  }
);

export default httpInstance;
